import { createOpenStore } from "stores/createOpenStore";

/** The table (and optionally the column) the link dialog opens pre-filled on. */
export interface LinkCreationOpen {
  firstTableId: string;
  firstColumnId?: string;
}

export const useLinkCreationStore = createOpenStore<LinkCreationOpen>();
